require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/fn/regexp/escape.js
// module id = 476
// module chunks = 99